<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Post Requirement</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-filud">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-8">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <div class="header_box version_2">
                  <h3>
                    <i class="fa fa-phone"></i> Receive Quotation from merchant
                    (user/tourist can see quotes by merchants and contact
                    merchants by visiting their profile)
                  </h3>
                </div>
                <form @submit.prevent="updateProfile()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="category"
                              >Occasion<sup style="color: red">*</sup></label
                            >
                            <select
                              name=""
                              class="form-control select2"
                              id="category"
                              required
                              v-model="event"
                            >
                              <option value="" v-if="event">{{ event }}</option>
                              <option value="" v-else>-Select-</option>
                              <option value="birthday">BirthDay</option>
                              <option value="anniversary">Anniversary</option>
                              <option value="party">Party</option>
                              <option value="engagement">Engagement</option>
                              <option value="baby-shower">Baby-shower</option>
                              <option value="farewell">Farewell</option>
                              <option value="retirement">Retirement</option>
                              <option value="others">Others</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              >Event Date<sup style="color: red">*</sup></label
                            >
                            <date-picker
                              v-model="event_date"
                              required
                              :config="datepickerconfig"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              >End Event Date<sup style="color: red"
                                >*</sup
                              ></label
                            >
                            <date-picker
                              v-model="event_end"
                              :config="datepickerconfig"
                              required
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Short Description<sup style="color: red"
                                >*</sup
                              ></label
                            >
                            <textarea
                              class="form-control"
                              v-model="short_description"
                            ></textarea>
                          </div>
                        </div>
                            <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Description<sup style="color: red">*</sup></label
                            >
                            <ckeditor
                              :editor="editor"
                              v-model="description"
                              :config="editorConfig"
                            ></ckeditor>
                          </div>
                        </div>
                      </div>
                      <!-- /row-->
                      <div class="row">
                        <div class="col-12">
                          <h5>Categories</h5>
                          <a
                            @click="openLoginModal()"
                            href="javascript:void(0);"
                            >Edit</a
                          >
                          <div class="form-group">
                            <div
                              class="form-check category"
                              v-for="(cat, index) in categories"
                              :key="index"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="cat.category_id"
                                v-model="category_id"
                              />
                              <label class="form-check-label" for="" >{{
                                cat.category
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="modal fade bd-example-modal-lg"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="myLargeModalLabel"
                        aria-hidden="true"
                      >
                      
                        <div class="modal-dialog modal-xl">
                          <div class="modal-content">
                            <Areaofinterest v-if="categories" :category_id="category_id" :category="categories" @clicked="onClickChild" />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6">
                          <label>Location<sup style="color: red">*</sup></label>
                          <input
                            class="form-control"
                            required
                            v-model="location"
                          />
                        </div>
                        <div class="col-lg-6">
                          <label>Pincode<sup style="color: red">*</sup></label>
                          <input
                            class="form-control"
                            required
                            type="number"
                            v-model="pincode"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">
                          <label>Files</label>
                          <input
                            class="form-control"
                            type="file"
                            @change="onFileChange"
                          />
                        </div>
                      </div>
                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <div id="pass-info" class="clearfix"></div>
                          <center>
                            <button
                              type="submit"
                              class="btn_1 rounded add_top_30 mb-4"
                            >
                              Post Requirement
                            </button>
                          </center>
                        </div>
                      </div>
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Areaofinterest from "../components/Areaofinterest.vue";
export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      categories: [],
      category_id: [],
      msg: null,
      classAlert: null,
      profile_img: null,
      image: "",
      location: "",
      pincode: "",
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(),
        maxDate: new Date().setMonth(new Date().getMonth() + 1),
      },
      description: "",
      short_description: "",
      event_end: "",
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        height: "500px",
      },
      event_date: "",
      event: "",
      file: null,
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Areaofinterest,
  },
  beforeMount() {
    this.checkToken();
    this.getAreaofinterest();
  },
  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
     onClickChild (value,id) {
   // someValue

           this.categories=value
           this.category_id=id
      },
    openLoginModal() {
      window.$(".bd-example-modal-lg").modal("show");
    },
    getAreaofinterest() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);
      API.get(
        `Postrequirement/singleList/${window.atob(this.$route.params.id)}`,
        {
          headers: { Authorization: token },
        }
      )
        .then((res) => {
          res.data.data.forEach((value) => {
            this.location = value.location;
            this.pincode = value.pincode;
            this.event_date = this.frontEndDateFormat(value.event_date);
            this.event_end = this.frontEndDateFormat(value.event_end);
            this.description = value.description;
            this.short_description = value.short_description;
            this.event = value.event;
            this.categories = value.categories;
          });
          // this.categories = res.data.data;
          this.categories.forEach((value) => {
            this.category_id.push(value.category_id);
          });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },
    updateProfile() {
      const form = new FormData();
      form.append("category_id", this.category_id);
      form.append("location", this.location);
      form.append("pincode", this.pincode);
      form.append("event_date", this.event_date);
      form.append("event_end", this.event_end);
      form.append("description", this.description);
      form.append("short_description", this.short_description);
      form.append("event", this.event);
      if (this.file != null) {
        form.append("file", this.file);
      }
      API.post(
        `Postrequirement/updatepost/${window.atob(this.$route.params.id)}`,
        form,
        {
          headers: { Authorization: this.token },
        }
      )
        .then((res) => {
          if (res.data.status == 200) {
            this.msg = "Your Profile updated Successfully";
            this.classAlert = "success";
            this.$router.push('/requirement-list');
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err;
          this.classAlert = "danger";
        });
      //axios
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.file = files[0];
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.image = "";
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";
.show_img,
.header_box img {
  width: 100px;
  height: 100px;
}
</style>